// extracted by css-extract-rspack-plugin
export default {"isLeft":"_ab12ad19"};